module.exports = __webpack_public_path__ + "static/media/avatar-4.c29f5faf.jpg";